<template>
	<div class="page">
		<div class="editionHeart" >
			<compCrumbs></compCrumbs>
		</div>
		<div class="userNameBox">
			<div class="editionHeart" style="display: flex;height: 100%;">
				<img :src="$public.getMemberPic(userInfo.userId)" class="userPic" @error="defImg"/>
				<div class="userName">{{userInfo.nickName}}</div>
				<div class="userPhone">{{userInfo.userMobile}}</div>
			</div>
		</div>
		<div class="editionHeart">
			<div class="con">
				<div class="L">
					<div class="userNameListBox">
						<div class="userNameListItem" :class="curNav==='info'?'active':''" @click="changeCurNav('info')">
							<img src="../../assets/img/my/infoIcon.png" style="vertical-align: middle;margin-right: 6px;height: 30px;;"/>
							个人资料
						</div>
						<div class="userNameListItem" :class="curNav==='order'?'active':''" @click="changeCurNav('order')">
							<img src="../../assets/img/my/orderIcon.png" style="vertical-align: middle;margin-right: 6px;height: 30px;;"/>
							宠物订单
						</div>
						<div class="userNameListItem" :class="curNav==='shipAddress'?'active':''" @click="changeCurNav('shipAddress')">
							<img src="../../assets/img/my/addrIcon.png" style="vertical-align: middle;margin-right: 6px;height: 30px;;"/>
							收货地址
						</div>
					</div>
				</div>
				<div class="R">
					<info v-if="curNav==='info'"></info>
					<orderList v-if="curNav==='order'"></orderList>
					<shipAddressList v-if="curNav==='shipAddress'"></shipAddressList>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import compCrumbs from "../../components/compCrumbs.vue"
	import info from "./info/info.vue"
	import shipAddressList from "./shipAddress/shipAddressList.vue"
	import orderList from "./order/orderList.vue"
	export default {
		components:{compCrumbs,shipAddressList,orderList,info},
		data() {
			return {
				curNav:'order',
			}
		},
		computed:{
			userInfo(){
				return this.$store.state.userInfo
			}
		},
		mounted(){
			this.curNav = this.$route.query.type
		},
		methods:{
			defImg(event){
				let img = event.srcElement;
				img.src = require('../../assets/img/my/defaultAcavar.png');
				img.onerror = null; //防止闪图
			},
			changeCurNav(str){
				this.curNav = str;
			}
		},
	}
</script>

<style lang="scss" scoped>
.page{
	.userNameBox{
		width:100%;height: 286px;background:url(../../assets/img/my/userBg.png) no-repeat;background-size: 100% 180px;
		.userPic{
			width:190px;height: 190px;border-radius: 50%;margin-top:50px;
		}
		.userName{
			font-size: 32px;color:#303042;margin:127px 0 0 30px;
		}
		.userPhone{
			font-size: 22px;color:#303042;margin:137px 0 0 30px;
		}
	}
	.con{
		display: flex;
		.L{
			width:251px;margin-right: 50px;flex-shrink: 0;
			.userNameListBox{
				box-sizing: border-box;height: 600px;
				.userNameListItem{
					text-align: center;line-height: 30px;font-size: 20px;cursor: pointer;width:251px;height: 80px;color:#303042;padding:25px 0;box-sizing: border-box;
					&.active{
						background:url(../../assets/img/my/navActive.png) no-repeat;background-size: 100% 100%;
					}
				}
			}
		}
		.R{
			width:100%;box-sizing: border-box;
		}
	}
}
</style>							
